<template>
  <div class="tree-node">
    <div 
      class="tree-node-content"
      :class="{
        'selected': category.id === selectedId,
        'disabled': isDisabled
      }"
      @click="selectCategory"
    >
      <span 
        v-if="category.children && category.children.length" 
        class="toggle"
        @click.stop="toggleExpand"
      >
        <b-icon :icon="isExpanded ? 'chevron-down' : 'chevron-left'" size="is-small"></b-icon>
      </span>
      <span v-else class="toggle-spacer"></span>
      
      <label class="node-label">
        <input 
          type="radio" 
          :value="category.id"
          :checked="category.id === selectedId"
          :disabled="isDisabled"
          @click.stop="selectCategory"
        />
        <span class="node-name">{{ category.name }}</span>
      </label>
    </div>
    
    <div v-if="isExpanded && category.children && category.children.length" class="tree-node-children">
      <tree-node
        v-for="child in category.children"
        :key="child.id"
        :category="child"
        :selected-id="selectedId"
        :disabled-ids="disabledIds"
        @select="$emit('select', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeNode',
  props: {
    category: {
      type: Object,
      required: true
    },
    selectedId: {
      type: Number,
      default: null
    },
    disabledIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    isDisabled() {
      return this.disabledIds.includes(this.category.id);
    }
  },
  methods: {
    toggleExpand() {
      if (!this.isDisabled) {
        this.isExpanded = !this.isExpanded;
      }
    },
    selectCategory() {
      if (!this.isDisabled) {
        this.$emit('select', this.category.id);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tree-node {
  user-select: none;
}

.tree-node-content {
  display: flex;
  align-items: center;
  padding: 8px 5px;
  gap: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover:not(.disabled) {
    background-color: #e9ecef;
  }

  &.selected {
    background-color: #d4edda;
    font-weight: 600;
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background-color: #f8f9fa;
  }
}

.toggle {
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.toggle-spacer {
  width: 20px;
  display: inline-block;
  flex-shrink: 0;
}

.node-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  flex: 1;

  input[type="radio"] {
    cursor: pointer;
    
    &:disabled {
      cursor: not-allowed;
    }
  }
}

.node-name {
  color: #2c3e50;
}

.tree-node-children {
  padding-right: 25px;
}
</style>
